import React from 'react';

function About() {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '32px 16px' }}>
        <h1 style={{ fontSize: '36px', fontWeight: 'bold', textAlign: 'center', marginBottom: '32px', color: '#e60012' }}>Hakkımızda</h1>
        
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', padding: '32px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '24px', color: '#374151' }}>Toyota Türkiye</h2>
            
            <div>
              <p style={{ marginBottom: '24px', color: '#6b7280', lineHeight: '1.6' }}>
                Toyota, dünya çapında güvenilir ve kaliteli araçlar üreten önde gelen otomotiv üreticilerinden biridir. 
                Türkiye'de de uzun yıllardır hizmet veren Toyota, müşteri memnuniyetini her zaman ön planda tutmaktadır.
              </p>
              
              <p style={{ marginBottom: '24px', color: '#6b7280', lineHeight: '1.6' }}>
                Geniş araç yelpazemiz, yenilikçi teknolojilerimiz ve mükemmel servis ağımızla, 
                sizlere en iyi sürüş deneyimini sunmaya devam ediyoruz.
              </p>
              
              <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', color: '#e60012' }}>Misyonumuz</h3>
              <p style={{ marginBottom: '24px', color: '#6b7280', lineHeight: '1.6' }}>
                Müşterilerimize güvenli, konforlu ve çevre dostu araçlar sunarak, 
                yaşam kalitelerini artırmak ve sürdürülebilir bir gelecek için katkıda bulunmak.
              </p>
              
              <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', color: '#e60012' }}>Vizyonumuz</h3>
              <p style={{ marginBottom: '24px', color: '#6b7280', lineHeight: '1.6' }}>
                Türkiye'nin en güvenilir ve tercih edilen otomotiv markası olmak, 
                teknolojik yeniliklerle sektöre öncülük etmek.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
